import React from 'react';

const WindowsFolder = ({ count, isHovered, size = 'normal' }) => {
  const sizeClasses = {
    small: 'w-16 h-14',
    normal: 'w-20 h-16',
    large: 'w-24 h-20',
  };

  return (
    <div className={`relative ${sizeClasses[size]}`}>
      <svg
        viewBox="0 0 100 85"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="w-full h-full drop-shadow-md"
      >
        {/* Onglet du dossier */}
        <path
          d="M2 15C2 12.2386 4.23858 10 7 10H35C36.3261 10 37.5979 10.5268 38.5355 11.4645L45.4645 18.3936C46.4021 19.3313 47.6739 19.858 49 19.858H93C95.7614 19.858 98 22.0966 98 24.858V28H2V15Z"
          fill="#FDB813"
          className={isHovered ? 'brightness-110' : ''}
        />

        {/* Dégradé de l'onglet (ombre) */}
        <path
          d="M2 15C2 12.2386 4.23858 10 7 10H35C36.3261 10 37.5979 10.5268 38.5355 11.4645L45.4645 18.3936C46.4021 19.3313 47.6739 19.858 49 19.858H93C95.7614 19.858 98 22.0966 98 24.858V28H2V15Z"
          fill="url(#gradient-tab)"
          opacity="0.3"
        />

        {/* Corps principal du dossier */}
        <path
          d="M2 28H98V78C98 80.7614 95.7614 83 93 83H7C4.23858 83 2 80.7614 2 78V28Z"
          fill="#FFCC00"
          className={isHovered ? 'brightness-110' : ''}
        />

        {/* Dégradé du corps (lumière) */}
        <path
          d="M2 28H98V78C98 80.7614 95.7614 83 93 83H7C4.23858 83 2 80.7614 2 78V28Z"
          fill="url(#gradient-body)"
          opacity="0.2"
        />

        {/* Bordure du dossier */}
        <path
          d="M2 15C2 12.2386 4.23858 10 7 10H35C36.3261 10 37.5979 10.5268 38.5355 11.4645L45.4645 18.3936C46.4021 19.3313 47.6739 19.858 49 19.858H93C95.7614 19.858 98 22.0966 98 24.858V78C98 80.7614 95.7614 83 93 83H7C4.23858 83 2 80.7614 2 78V15Z"
          stroke="#D9A520"
          strokeWidth="1.5"
          className={isHovered ? 'stroke-yellow-600' : ''}
        />

        {/* Ombre intérieure pour la profondeur */}
        <path
          d="M5 30H95V78C95 79.6569 93.6569 81 92 81H8C6.34315 81 5 79.6569 5 78V30Z"
          fill="black"
          opacity="0.03"
        />

        {/* Définitions des dégradés */}
        <defs>
          <linearGradient id="gradient-tab" x1="50" y1="10" x2="50" y2="28" gradientUnits="userSpaceOnUse">
            <stop offset="0%" stopColor="#FFFFFF" />
            <stop offset="100%" stopColor="#000000" />
          </linearGradient>
          <linearGradient id="gradient-body" x1="50" y1="28" x2="50" y2="83" gradientUnits="userSpaceOnUse">
            <stop offset="0%" stopColor="#FFFFFF" />
            <stop offset="100%" stopColor="#FDB813" />
          </linearGradient>
        </defs>
      </svg>

      {/* Badge de compteur */}
      {count > 0 && (
        <div className={`absolute ${size === 'small' ? '-top-1 -right-1 min-w-[20px] h-5 text-[10px] border' : '-top-2 -right-2 min-w-[24px] h-6 text-xs border-2'} bg-red-500 text-white font-bold rounded-full flex items-center justify-center shadow-lg px-1.5 border-white`}>
          {count}
        </div>
      )}
    </div>
  );
};

export default WindowsFolder;
